export const reduceProjectContent = (project: any): any => {
    const { variants, ...rest } = project;
    return { ...rest };
};